/** `/api/v2/admin` – nur für `role === 'admin'` (der Server erzwingt es). */
import { http } from './http'
import type {
  AssignLicenseRequest,
  CreateTherapistRequest,
  LicenseAssignment,
  LicenseType,
  PatchTherapistRequest,
  SetPasswordRequest,
  TherapistAdmin,
} from './types'

export function listTherapists(): Promise<TherapistAdmin[]> {
  return http.get<TherapistAdmin[]>('/admin/therapists')
}

export function createTherapist(payload: CreateTherapistRequest): Promise<TherapistAdmin> {
  return http.post<TherapistAdmin>('/admin/therapists', payload)
}

export function patchTherapist(
  id: number,
  payload: PatchTherapistRequest,
): Promise<TherapistAdmin> {
  return http.patch<TherapistAdmin>(`/admin/therapists/${id}`, payload)
}

export function setTherapistPassword(id: number, payload: SetPasswordRequest): Promise<void> {
  return http.patch<void>(`/admin/therapists/${id}`, payload)
}

export function deleteTherapist(id: number): Promise<void> {
  return http.delete<void>(`/admin/therapists/${id}`)
}

export function listLicenseTypes(): Promise<LicenseType[]> {
  return http.get<LicenseType[]>('/admin/license-types')
}

export function listLicenseAssignments(): Promise<LicenseAssignment[]> {
  return http.get<LicenseAssignment[]>('/admin/license-transactions')
}

export function assignLicense(payload: AssignLicenseRequest): Promise<LicenseAssignment> {
  return http.post<LicenseAssignment>('/admin/license-transactions', payload)
}

export const adminApi = {
  listTherapists,
  createTherapist,
  patchTherapist,
  setTherapistPassword,
  deleteTherapist,
  listLicenseTypes,
  listLicenseAssignments,
  assignLicense,
}
